/** 適用品項中文標籤（對照後端 applicable_items enum）。 */
const APPLICABLE_ITEMS_LABEL: Record<string, string> = {
  all: "全部商品適用",
  gas_only: "僅瓦斯適用",
  accessories_only: "僅配件適用",
};

export const applicableItemsLabel = (value?: string | null): string =>
  (value && APPLICABLE_ITEMS_LABEL[value]) || "全部商品適用";

/**
 * 此券的適用品項在 App 是否可選用。
 * App 購物車目前只有瓦斯，「僅配件(accessories_only)」券永遠套不到瓦斯訂單
 * （後端會以 COUPON_SCOPE_NOT_MATCH 打回），故不自動帶入、不可手動選。
 * all / gas_only 皆適用瓦斯。
 */
export const isApplicableItemsSelectableInApp = (value?: string | null): boolean =>
  value !== "accessories_only";
